import { useState } from 'react';
import { useT, type Dictionary } from '../i18n';
import { cn } from '../lib/cn';
import { haptic } from '../lib/tma';
import { BottomSheet, Button } from './ui';

export type HelpTopic = keyof Dictionary['help']['topics'];

/**
 * The one hint element of the app (spec 6): a small «?» next to a title or a
 * word; a tap opens a bottom sheet with the title, a few sentences and «Понятно».
 */
export function HelpHint({ topic, className }: { topic: HelpTopic; className?: string }) {
  const t = useT();
  const [open, setOpen] = useState(false);
  const hint = t.help.topics[topic];
  return (
    <>
      <button
        type="button"
        aria-label={t.help.open}
        onClick={(e) => {
          e.preventDefault();
          e.stopPropagation();
          haptic('light');
          setOpen(true);
        }}
        className={cn(
          'inline-flex items-center justify-center w-[18px] h-[18px] rounded-full bg-surface-2 text-hint',
          'text-[11px] font-bold leading-none normal-case tracking-normal align-middle flex-shrink-0',
          'active:scale-95 transition-transform',
          className,
        )}
      >
        ?
      </button>
      <BottomSheet open={open} onClose={() => setOpen(false)} title={hint.title}>
        <p className="text-sm leading-relaxed mb-4 break-words">{hint.body}</p>
        <Button variant="ink" fullWidth onClick={() => setOpen(false)}>
          {t.help.ok}
        </Button>
      </BottomSheet>
    </>
  );
}
